<template>
  <div class="auth-steps">
    <aside class="auth-steps__panel">
      <img
        src="../../assets/safetyPlanner_logo_white.png"
        alt="safetyPlanner"
        class="auth-steps__logo"
      />
      <ol class="auth-steps__list">
        <li
          v-for="(label, idx) in steps"
          :key="idx"
          class="auth-steps__item"
          :class="{
            'auth-steps__item--active': idx + 1 === step,
            'auth-steps__item--done': idx + 1 < step,
          }"
        >
          <span class="auth-steps__number">{{ idx + 1 }}</span>
          <span class="auth-steps__label">{{ label }}</span>
        </li>
      </ol>
    </aside>
    <main class="auth-steps__main">
      <div class="auth-steps__card">
        <slot />
      </div>
      <a
        class="auth-steps__footer"
        href="https://www.safetyplanner.de"
        target="_blank"
        rel="noopener"
      >
        www.safetyplanner.de
      </a>
    </main>
  </div>
</template>

<script>
export default {
  name: "authStepsLayout",
  props: {
    step: { type: Number, default: 1 },
  },
  computed: {
    steps() {
      return [
        this.$t("login.steps.register"),
        this.$t("login.steps.verify"),
        this.$t("login.steps.start"),
      ];
    },
  },
};
</script>

<style scoped>
.auth-steps {
  display: flex;
  min-height: 100vh;
}

.auth-steps__panel {
  position: relative;
  flex: 0 0 320px;
  background: #1a5561;
  color: #ffffff;
  padding: 56px 40px;
}

.auth-steps__logo {
  display: block;
  width: 210px;
  margin-left: -14px;
}

.auth-steps__list {
  list-style: none;
  padding: 0;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40px;
  transform: translateY(-50%);
}

.auth-steps__item {
  position: relative;
  display: flex;
  align-items: center;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
}

.auth-steps__item + .auth-steps__item {
  margin-top: 34px;
}

.auth-steps__item + .auth-steps__item::before {
  content: "";
  position: absolute;
  left: 17px;
  bottom: 36px;
  height: 34px;
  border-left: 2px solid #ffffff;
}

.auth-steps__number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffffff;
  color: #1a5561;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 400;
  margin-right: 14px;
  flex-shrink: 0;
}

.auth-steps__item--active .auth-steps__number,
.auth-steps__item--done .auth-steps__number {
  background: #45d6f4;
  color: #1a5561;
}

.auth-steps__item--active .auth-steps__label {
  color: #45d6f4;
}

.auth-steps__main {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px 96px;
  background: #45d6f41a;
}

.auth-steps__card {
  width: 100%;
  max-width: 690px;
  background: #ffffff;
  border-radius: 8px;
  padding: 56px 60px 48px;
}

.auth-steps__footer {
  position: absolute;
  bottom: 28px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 14px;
  color: #1a5561;
  text-decoration: none;
}

.auth-steps__footer:hover {
  text-decoration: underline;
}

@media (max-width: 960px) {
  .auth-steps {
    flex-direction: column;
  }
  .auth-steps__panel {
    flex: none;
    padding: 20px 24px;
  }
  .auth-steps__list {
    display: none;
  }
  .auth-steps__card {
    padding: 32px 24px;
  }
}
</style>
